export const CARD_RADIUS = 16;
export const CARD_SHADOW = 'shadow-[0_16px_34px_rgba(15,23,42,0.12)]';
export const GAP_Y = 'py-8 md:py-12';
export const SECTION_MAX_WIDTH = 'max-w-[80.5rem]';
